import React from 'react';
import { Avatar, Typography, TableCell } from '../../../UIKit';
import { getInitials } from '../../../Helpers/String.helper';
import { CellProps } from './CellProps';
import { makeStyles } from '~/UIKit/Style';

export interface CustomerCellProps extends CellProps {
  value: {
    customerDisplayname: string;
    imageId: string;
  };
}

const useStyles = makeStyles({
  cell: {
    padding: 0,
  },
  root: {
    display: 'flex',
  },
  avatar: {
    width: 30,
    height: 30,
    marginRight: 15,
  },
});

const CustomerCell = ({ value, className }: CustomerCellProps) => {
  const { classes } = useStyles();

  // We have to split the displayname as it's the only value we get here :)
  const customerName = value.customerDisplayname.split(', ');
  const initials = getInitials(customerName[0], customerName[1]);

  return (
    <TableCell className={`${classes.cell} ${className}`}>
      <div className={classes.root}>
        <div>
          {value.imageId ? (
            <Avatar
              alt={value.customerDisplayname}
              className={classes.avatar}
              src={value.imageId}
            />
          ) : (
            <Avatar className={classes.avatar}>{initials}</Avatar>
          )}
        </div>
        <div>
          <Typography>{value.customerDisplayname}</Typography>
        </div>
      </div>
    </TableCell>
  );
};

export default CustomerCell;
